import { Controller } from 'stimulus';

function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0;
      var v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
}

export default class extends Controller {
  static targets = [
    'list',
    'newLocaleConfigurationTemplate',
  ];

  onAddLocaleConfiguration() {
    const template = this.newLocaleConfigurationTemplateTarget.innerHTML
    const content = template.replace(/idTemplate/g, generateUUID().slice(0, 6))
    this.listTarget.insertAdjacentHTML('beforeend', content)
  }

  onDeleteLocaleConfiguration(event) {
    this.#localeConfigurationEl(event.target).remove()
  }

  #localeConfigurationEl(childEl) {
    return childEl.closest('.locale-configuration-fields')
  }
}
